import React from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import styles from './Download.module.sass'

const items = [
  {
    title: 'Appstore',
    content: 'Download from',
    image: '/images/content/apple.svg',
    url: '/',
  },
  {
    title: 'Google Play',
    content: 'Download from',
    image: '/images/content/google-play.svg',
    url: '/',
  },
  {
    title: 'Mac OS',
    content: 'Download for',
    image: '/images/content/apple.svg',
    url: '/',
  },
]

const Download = () => {
  return (
    <div className={cn('section-mb0', styles.download)}>
      <div className={cn('container', styles.container)}>
        <div className={cn('bg', styles.bg)}>
          <img
            srcSet="/images/content/crypto/new-crypto-images/trade-anywhere-banner.png"
            src="/images/content/crypto/new-crypto-images/trade-anywhere-banner.png"
            alt="Download"
          />
        </div>
        <div className={styles.wrap}>
          <h2 className={cn('h2', styles.title)}>Trade Anywhere, Anytime!</h2>
          {/* <div className={styles.info}>
            Instantly trade crypto on-the-go with FiniticX. Anytime, anywhere!
          </div> */}
          <div className={styles.list}>
            {items.map((x, index) => (
              <Link className={styles.item} key={index} to={x.url}>
                <div className={cn('download-icon', styles.icon)}>
                  <img src={x.image} alt="Logo" />
                </div>
                <div className={styles.details}>
                  <div className={styles.content}>{x.content}</div>
                  <div className={styles.subtitle}>{x.title}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Download
